<script>
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";

import StoreTab from './Part/StoreTab.vue';
import ReservationTab from './Part/ReservationTab.vue';
import UserTab from './Part/UserTab.vue';
import StuffTab from './Part/StuffTab.vue';

export default {
    components: {
        Layout,
        PageHeader,

        StoreTab,
        ReservationTab,
        UserTab,
        StuffTab
    },
    data() {
        return {
            tabIndex: 0,
        };
    },
    created() {
        var vm = this;

        vm.syncTabFromRoute();
    },
    watch: {
        tabIndex(newVal) {
            this.updateTabQuery(newVal);
        }
    },
    methods: {
        syncTabFromRoute() {
            var index = this.$route.query.tabIndex;

            if (index !== undefined) {
                this.tabIndex = Number(index);
            }
        },
        updateTabQuery(index) {
            const current = Number(this.$route.query.tabIndex);

            if (current !== index) {
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        tabIndex: index
                    }
                });
            }
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="$t('config_general.title.detail')" :pageTitle="$t('menu.sub_header.dashboard')" />

        <BRow>
            <BCol lg="12">
                <BTabs nav-class="nav-primary mb-3" pills lazy v-model="tabIndex">
                    <hr class="border-dashed">
                    <BTab :title="$t('config_general.tab.reservation')" class="pt-2" v-if="$ac.hasAccess('config_general_create')">
                        <ReservationTab />
                    </BTab>
                    <BTab :title="$t('config_general.tab.store')" class="pt-2" v-if="$ac.hasAccess('config_general_create')">
                        <StoreTab />
                    </BTab>
                    <BTab :title="$t('config_general.tab.stuff')" class="pt-2" v-if="$ac.hasAccess('config_general_create')">
                        <StuffTab />
                    </BTab>
                    <BTab :title="$t('config_general.tab.user')" class="pt-2" v-if="$ac.hasAccess('config_general_create')">
                        <UserTab />
                    </BTab>
                </BTabs>
            </BCol>
        </BRow>
    </Layout>
</template>